(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('WeeklyWorkDay', WeeklyWorkDay);

    WeeklyWorkDay.$inject = ['$resource'];

    function WeeklyWorkDay($resource) {
        var resourceUrl = 'api/weekly-work-days/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
